// src/App.jsx
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { ROUTES } from "./constants";

// Pages
import Welcome from "./pages/Welcome";
import Home from "./pages/Home";
import MisReclamos from "./pages/MisReclamos";
import Perfil from "./pages/Perfil";
import GestionarReclamos from "./pages/GestionarReclamos";
import GestionarUsuarios from "./pages/GestionarUsuarios";
import DashboardAdmin from "./pages/Dashboard";
import ReclamoDetalle from "./pages/ReclamoDetalle";

// Components
import LoginForm from "./components/auth/LoginForm";
import Register from "./components/auth/register/Register";
import Sidebar from "./components/layout/Sidebar";

function App() {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          {/* Rutas públicas */}
          <Route path={ROUTES.WELCOME} element={<Welcome />} />
          <Route path={ROUTES.LOGIN} element={<LoginForm />} />
          <Route path={ROUTES.REGISTER} element={<Register />} />

          {/* Rutas protegidas con Sidebar */}
          <Route path="/" element={<Sidebar />}>
            <Route path={ROUTES.HOME} element={<Home />} />
            <Route path={ROUTES.DASHBOARD} element={<DashboardAdmin />} />
            <Route path={ROUTES.MIS_RECLAMOS} element={<MisReclamos />} />
            <Route path={ROUTES.PERFIL} element={<Perfil />} />
            <Route path={ROUTES.GESTIONAR_RECLAMOS} element={<GestionarReclamos />} />
            <Route path={ROUTES.GESTIONAR_USUARIOS} element={<GestionarUsuarios />} />
            <Route path={ROUTES.RECLAMO_DETALLE} element={<ReclamoDetalle />} />
          </Route>

          {/* Ruta 404 - Redirigir a home */}
          <Route path="*" element={<Navigate to={ROUTES.HOME} replace />} />
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;